import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { useLocation, useNavigate } from 'react-router-dom';
import AdminSidebar from '../components/AdminSidebar';
import '../style/common.css';

function POList() {
  const [pos, setPOs] = useState([]);
  const [currentFilter, setCurrentFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const filter = queryParams.get("filter") || "all";

  useEffect(() => {
    const fetchPOs = async () => {
      try {
        setLoading(true);
        const snapshot = await getDocs(collection(db, 'purchase_orders'));
        const allPOs = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        let filtered = allPOs;

        if (filter === 'active') {
          filtered = allPOs.filter(po => !po.completed);
        } else if (filter === 'completed') {
          filtered = allPOs.filter(po => po.completed);
        }

        setPOs(filtered);
        setCurrentFilter(filter);
        setLoading(false);
      } catch (err) {
        console.error('Error loading POs:', err);
        setLoading(false);
      }
    };

    fetchPOs();
  }, [filter]);

  const getTitle = () => {
    if (currentFilter === 'active') return 'Running Purchase Orders';
    if (currentFilter === 'completed') return 'Closed Purchase Orders';
    return 'All Purchase Orders';
  };

  const filteredPOs = pos.filter(po => {
    const search = searchTerm.toLowerCase();
    return (
      po.po_number?.toLowerCase().includes(search) ||
      po.jc_number?.toLowerCase().includes(search) ||
      po.description?.toLowerCase().includes(search)
    );
  });

  if (loading) return <div>Loading PO data...</div>;

  return (
    <div className="dashboard-wrapper">
      <AdminSidebar />
      <div className="dashboard-content">
        <h2>{getTitle()}</h2>

        <div className="form-group" style={{ maxWidth: 300, marginBottom: '1rem' }}>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search PO No, JC No, or Description"
            style={{ padding: '0.5rem', width: '100%' }}
          />
        </div>

        {filteredPOs.length === 0 ? (
          <p>No matching POs found.</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table className="styled-table">
              <thead>
                <tr>
                <th>JC Number</th>
                  
                  <th>PO Number</th>
                  <th>Total Amount (₹)</th>
                  <th>GST</th>
                  <th>Description</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredPOs.map(po => (
                  <tr
                    key={po.id}
                    style={{ cursor: 'pointer' }}
                    onClick={() => navigate(`/admin/po-detail/${po.id}`)}
                  >
                    <td>{po.jc_number || 'N/A'}</td>
                   
                    <td>{po.po_number}</td>
                    <td>₹{po.po_total_amount}</td>
                    <td>{po.tax_percentage > 0
    ? po.tax_percentage
    : po.gst > 0
    ? po.gst
    : po.tax_percent > 0
    ? po.tax_percent
    : 0}</td>
                    <td>{po.description || 'N/A'}</td>
                    <td style={{ color: po.completed ? 'green' : 'orange', fontWeight: 600 }}>
                      {po.completed ? 'Completed' : 'Active'}
                    </td>
                    
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default POList;
